const zh = {
    navBar: {
        smartSpace: 'IN+智慧平台',
        smartProduct: '智慧产品',
        news: '新闻动态',
        joinUs: '加入我们',
        cooperation: '商务合作',
        classicCase: '经典案例',
        aboutUs: '关于我们',
        contactUs:'联系我们'
    },
    //下拉菜单
    AppHeader:{
        a:"智慧出行",
        b:"智慧空间",
        c:"智慧物流",
        d:"智慧零售",
        ee:"汽车电子",
        e:"交通出行",
        f:"共享单车智能锁",
        g:"共享助力车智能锁",
        h:"共享滑板车智能锁",
        i:"车联网",
        j:"T-BOX解决方案",
        k:"OBD解决方案",
        kk:'环保T-BOX解决方案',
        m:"in+智慧门锁",
        n:"智慧物流包装",
        o:"无人零售柜",
        p:"商超智能购物锁",
        q:"科技行业",
        u:"互联网行业",
        v:"零售行业",
        y:"公司动态",
        z:"媒体报道",
        one:"行业资讯",
        two:"企业简介",
        three:"企业文化",
        four:"管理团队",
        five:"发展历程"
    },
    //首页
    smartSpace: {
        Telematics:'领先的车联网及',
        Telematicschild:'物联网解决方案提供商',
        Internet:'具备物联网应用领域的集成服务能力可自研自产自销',
        bicycle:'单车锁核心供应商',
        core:{
            a:'持续运用物联网及车联网应用层技术赋能B端，服务C端，聚焦不同业务场景',
            b:'智慧出行',
            c:'智慧空间',
            d:'智慧物流',
            e:'智慧零售',
            f:'汽车电子',
        },
        tab: {
            tabOne: "核心优势",
            tabTwo: "与新经济企业一起成长，相互成就",
            tabThree: "快速发展的云伽未来",
            tabFour: "在产业链上下游建立广泛而稳定的合作关系"
        },
        tabOne:{
            smartpoor:"全生命周期服务",
            smartoffice:"具备智能硬件从从研发、生产、 制造、维修、回收的全生命周期 客户服务能力",
            smarttravel:"10年技术沉淀",
            seemore:"积累了丰富的车联网、",
            officeText:"物联网技术开发经验以及数据沉淀",
            a:'软硬结合的全栈解决方案',
            b:'基于软硬件整合能力和对车联网、物联网的深刻理解，',
            c:'可提供不同场景的全栈解决方案'
        },
        tabTwo:{
            car:'车联网',
            more:'了解更多',
            a:'两轮出行',
            b:'科技行业',
            c:'互联网行业',
            d:'零售行业',
        },
        tabThree:{
            one:'相约山东济南,朗仁科技在第86届全国汽配会等你！',
            two:'10月11日-13日，第86届全国汽配会将在山东济南西部会展中心举办，朗仁科技携H6系列汽车、柴油车智能诊断平台参展。',
            three:'深耕·超越·共赢，朗仁科技第六届经销商年会圆满落幕！',
            four:'2019朗仁全国经销商年会启动！我们在这里，在这里等你！'
        },
        Earth:'服务全球企业客户',
        Earthtext:'业务范围遍布中国、南美、北美、欧洲、中东、东南亚等区域'
    },
    //智慧产品
    smartDetail: {
        top:'努力为客户提供',
        taba:'最专业的设备和服务',
        tab: {
            tabOne: "智能单车锁",
            tabTwo: "智能锁",
            tabThree: "滴滴（青桔）",
            tabFour: "智能汽车硬件",
            tabFive:"T-BOX借助移动通讯网络可以进行车辆实时位置跟踪、紧急/异常状态提示、行驶路线监测、营运调度管理、车况数据采集，并可以将各种行车数据及定位状况无线上传至中心，中心可随时监控车辆状况。",
            tabSix:"应用产品",
            tabSeven:"车咪",
            tabEight:"玻璃门智慧锁",
            tabDetail:"In+玻璃门智慧锁是一款辅助办公管理、门店管理等线下场景的智能门锁，支持指纹、app、手机靠一靠开锁等多种方式，后台管理者可在 PC 端和 APP 平台内完成内部员工、临时访客、场所、房门等 信息的录入、授权、管理，支持对锁群的统一管理，可精准授权到单锁，包含单锁的有效使用人、有效使用时段、权限有效期等，支持数据分析和可视化数据报表 ，如有效经营时间 ，办公时效比等 ，为经营管理决策提供更多依据 ，提升管理效率",
            tabTen:"腾讯路宝",
            tabEle:"路宝盒子"
        }
    },
    //经典案例
    classicCase:{
        tab:{
            a:"案例详情",
            b:"共享出行",
            c:"共享单车",
            d:"共享滑板车",
            e:"共享助力车",
            f:"滴滴(青桔)单车智能车锁",
            h:"车联网",
            i:"汽车厂商",
            j:"二手车平台",
            k:"政府客户",
            l:"戴姆勒",
            m:"近两年，汽车分时租赁被看作新的风口，共享汽车如雨后春笋。作为全球最大的商用车制造商，戴姆勒在共享汽车领域的布局早在8年之前，而云伽则是戴姆勒共享汽车Car2Go智能车载终端T-BOX的供应商。Car2go以奔驰smart组成单程、自由流动式汽车即时共享体系，采用APP寻找车辆+智能卡解锁的方式，朗仁科技供应的T-BOX终端，可以提供车辆定位跟踪、远程车况监控、甚至远程控制等数据通讯和车联网服务。",
            n:"科技行业",
            o:"中兴",
            p:"与中兴物联合作研发面向车载领域的智能产品，适合运营商、互联网企业、保险公司、租赁车队与智能手机、PC端管理系统采用4G方式连接通讯，支持OBDII/EOBD协议，对检测出的故障提供专业的解决方法和建议。",
            q:"互联网行业",
            u:"腾讯",
            v:"早在2014年，腾讯就推出的路宝盒子车载智能平台，其终端产品就是由云伽研发生产的。腾讯看中云伽多年来在汽车诊断领域的行业背景和数据积累，其旗下OBD诊断设备具有专业汽车级全系统诊断能力，最接近汽车底层数据及车机核心，能从标准化的接口中读取不同品牌、不同车型的信息，路宝盒子能够兼容几乎所有乘用车品牌十几年间出产的多达98%以上车型，且检测精确，运行稳定，这是其他车联网方案提供商所没有的。",
            w:"零售行业",
            x:"瑞幸咖啡",
            y:"为瑞幸提供无人零售咖啡机控制器以及门店智能管理终端门锁（ODM）",
            aaa:"出门问问",
            bbb:"好好开车",
            ddd:"大疆创新",
            eee:"上汽通用五菱",
            fff:"北汽国际",
            ggg:"东风小康",
            gggDetail:"东风小康专用车联网智能诊断系统，检测功能覆盖东风小康旗下所有车型，定制化实现手机、智能平板、PC端三种远程诊断方式，个性化云数据库功能满足车厂对车辆诊断数据的收集、分析，辅助提升车辆品质以及服务站维修服务质量。",
            hhh:"优信",
            iii:"针对优信二手车诊断项目所设计的方案，利用vci自诊端盒子对车辆进行全系统的检测，数据后台利用诊断盒子所收集的数据形成专业、有公信力的车辆残值评估报告，于手机APP上可自行进行报告查看。",
            kkk:"摩拜单车智能车锁",
            kkkDetail:"摩拜单车专利智能锁采用了新一代物联网技术，集成了“北斗+GPS+格洛纳斯”三模卫星定位芯片和物联网通信芯片及模块，通过智能APP让用户随时定位并使用最近的摩拜单车智能锁，实现了对于车辆位置和状态的高精度、智能化实时管理，并能持续获得骑行大数据。云伽自2015年起即与摩拜共同研发智能锁并成为其智能锁供应商，于2016年获得摩拜单车优秀合作伙伴称号，如今双方智能锁的开发已经进入第二代，共同利用物联网技术，为城市的绿色出行和可持续发展做贡献。在合作中我们承担了预研、设计开发、贴片、测试、售后维修、报废回收再利用全生命周期管理的工作。",
            mmm:"摩拜共享滑板车",
            mmmDetail:"摩拜共享滑板车智能中控 --- 我司承担了预研、设计开发、贴片、测试、售后维修、报废回收再利用全生命周期管理",
            nnn:"摩拜共享助力车",
            nnnDetail:"摩拜共享助力车智能中控我司承担了预研、设计开发、贴片、测试、售后维修、报废回收再利用全生命周期管理。"
        }
    },
    //商务合作
    cooperation:{
        tab:{
            a:"合作计划",
            b:"云伽未来致力于为企业级及零售级客户提供面向不同场景的物联网解决方案，",
            e:"为提升客户的生活方式及商业决策提供依据。",
            ee:"云伽未来秉承互助共赢的合作态度，与业界共同打造健康的生态体系。",
            c:"合作方式",
            d:"包含各类可以提升",
            f:"行业应用解决方案能力的供应链合作商。",
            g:"如芯片商、 模组商",
            h:"与区域渠道及行业渠道",
            i:"合作伙伴一同携手打造",
            j:"符合行业需求、提升行业",
            k:"向特定的合作伙伴",
            m:"提供定制产品的OEM",
            n:"共同为客户提供",
            o:"更高性价比的产品和服务",
            p:"合作伙伴",
            aaa:"申请合作"
        }
    },
    //加入我们
    joinUs: {
        tap: {
            a: "加入我们",
            b: "云伽福利",
            c: "有薪假期",
            d: "带薪年假、病假",
            e: "政府安居房",
            f: "申请安居房入住",
            g: "精彩团建",
            h: "形式多样的部门团建活动",
            i: "丰富活动",
            j: "惊喜连连的下午茶",
            k: "生日party",
            m: "节假日庆典",
            n: "内部体育赛事活动",
            o: "培训体系",
            p: "完备的内训及外训体系",
            q: "薪酬提升",
            u: "提供具有外部竞争力和内部",
            v: "竞争力的薪酬、绩效体系",
            w: "办公氛围",
            x: "公司环境",
            z: "团队风采",
            y:"“按时、保质、交付”的工作理念",
            y2:"以工程师文化为主导",
            y3:"自由平等沟通",
            y4:"以结果为导向，而不是等级观念",
            y5:"多元化融合",
            y6:"与来自各行各业",
            y7:"不同背景的优秀同事一起共事",
            one: "篮球比赛",
            aa:"团队风采",
            bbb:"公司前台",
            ccc:"空间一览",
            ddd:"内部环境",
            two: "公司团建",
            three: "招聘中心",
            four: "社会招聘",
            five: "校园招聘",
            six: "工作地点",
            seven: "全部",
            eight: "深圳",
            nine: "职位类别",
            ten: "市场",
            a1: "品牌",
            a2: "职能",
            a3: "投资",
            a4: "IT技术",
            b1: "更新时间",
            c1: "研发经理/研发总监",
            c2: "深圳-福田区  |  5-7年经验  |  本科  |  招1人  |",
            c3: "发布于：2019.11.11",
            c5: "Android系统工程师",
            e1: "硬件测试工程师",
            e2: "岗位职责：",
            e3: "1.根据产品功能制定测试思路以及详细测试方案；",
            e4: "2.整理产品测试报告，并与研发部门、生产测试部门沟通协作；",
            e5: "3.编写测试文档，输出测试报告等 。",
            f1: "任职资格：",
            f2: "1.电子、通信相关专业，大专及以上学历，2年以上工作经验；",
            f3: "2.具备手持终端硬件测试经验，有平板或手机或PDA硬件测试工作经验者优先；",
            f4: "3.熟练了解电路设计EDA工具（如ORCAD、PADS等）查看原理图；",
            f5: "4.了解EMC设备/网络分析仪/频谱仪的使用测试方法，具备EMC/BT/WIFI问题定位能力；",
            f6: "5.能熟练的使用示波器和万用表等工具；",
            f7: "6.参与过多个量产产品的硬件测试；",
            f8: "7.良好的沟通能力、做事踏实、主动积极、具备团队协作精神。",
            g1:"发布于：2019.10.1",
            g2:"2019/7",
            g3:"2019/8",
            g4:"2019/10",
            g5:"2019/11",
            g6:"深圳-福田区  |  2年经验  |  大专  |  招1人  |"
        }
    },
     //在线申请
     apply: {
        a: "在线申请",
        b: "请确保填写内容真实，联系方式畅通，工作人员会尽快与贵公司联系",
        c: "公司全称：",
        d: "联系人：",
        e: "邮箱：",
        f: "电话：",
        g: "所在地区：",
        h: "合作需求",
        i: "我已阅读并同意",
        j: "隐私政策",
        k: "和",
        l: "免责声明",
        m: "确认提交"
    },
    //智慧产品的详情页
    product:{
        a:"概述",
        b:"产品优势",
        c:"产品功能",
        d:"应用场景",
        moby:{
            a:"摩拜单车锁",
            b:"集成了“北斗+GPS” 卫星定位芯片和物联网通信芯片及模块，通过智能手机APP让用户随时随地定位并使用最近的共享单车、支持扫码开锁、短信开锁、GPRS开锁、蓝牙开锁，每种开锁方式独立运行，多种选择满足不同专业需求。",
        },
        didi:{
            a:"滴滴单车锁",
            b:"利用采用“北斗+GPS”双模卫星定位的共享单车智能锁硬件，为智能出行提供物联网入网接入的技术手段：通过网络与云端联系，传输指令，并收集新车信息数据，为企业精细化运营，社会出行大数据服务提供支持",
            c:"极端环境工作",
            e:"极端环境工作: 可在-30℃-60℃的 环境下工作",
            f:"GPS+北斗，双模卫星定位",
            g:"支持扫码开锁与蓝牙开锁",
            h:"通过网络通信或短距离通信，接收开锁指令、完成开锁上报和关锁上报等基本通信业务",
            i:"通过2G实现锁与服务器后台的点对点通信 •BLE4.0，无线覆盖距离 10米，支持扩展停车的无线围栏功能 •支持OTA",
            k:"支持空中升级（FOTA），通过服务器对锁具内部的各个模块进行程序升级，包括但不限于蓝牙模块和通信模块",
            m:"蜂鸣器声音提醒，带LED灯光提示",
            j:"定位和位置上报功能",
            n:"功耗管理和上报功能"
        },
        tBox:{
            a:"T-BOX",
            b:"T-BOX借助移动通讯网络可以进行车辆实时位置跟踪、紧急/异常状态提示、行驶路线监测、营运调度管理、车况数据采集，并可以将各种行车数据及定位状况无线上传至中心，中心可随时监控车辆状况。通过全过程记录、监控车辆的运行状态，给共享汽车监控、汽车融资租赁、物流运输企业、企事业单位车辆的科学管理提供依据。",
        },
        iobd2:{
            a:"iOBD2",
            b:"智能硬件、操作系统、通信运营商及服务提供商之间形成一个闭环的结构，采用4G方式连接通讯，通过OBD盒子读取车辆信息，传送至云平台，通过运算，将信息或诊断结果、解决方法建议发送至手机APP等操作系统，使车辆和APP形成连接，用户可随时进行自检读取汽车信息。",
        },
        in:{
            a:"In+",
            b:"In+玻璃门智慧锁是一款辅助办公管理、门店管理等线下场景的智能门锁，支持指纹、app、手机靠一靠开锁等多种方式，后台管理者可在 PC 端和 APP 平台内完成内部员工、临时访客、场所、房门等 信息的录入、授权、管理，支持对锁群的统一管理，可精准授权到单锁，包含单锁的有效使用人、有效使用时段、权限有效期等，支持数据分析和 可视化数据 报表 ，如有效经营时间 ，办公时效比等 ，为经营管理决策提供更多依 据 ，提升管理效率。",
        }
    },
     //关于我们
     aboutUs:{
        one:'企业简介',
        two:'企业文化',
        four:'发展历程',
        five:'荣誉资质',
        six:'研发实力',
        seven:'智享学院',
        tabtwo:{
            Culture:'愿景',
            Culture0:'核心价值观',
            Culture1:'使命',
        },
        tabfour:{
            j:'2010年',
            k:'2012年',
            d:'2014年',
            e:'2015年',
            f:'2016年',
            g:'2017年',
            h:'2018年',
            i:'2019年'
        },
        tabfive:{
            a:'“摩拜单车”', a1:'2016年',a2:'优秀合作伙伴',
            b:'“中兴物联”', b1:'优秀合作伙伴',
            c:'“车米杯”',c1:'创新新锐企业奖',c2:'第二届',
            d:'“中国锁业界战略联盟”',d1:'优秀供应商',
            e:'CE认证',
            f:'瑞幸咖啡',f1:'蓝色伙伴',f2:'2019年',
            g:'高新技术企业证书',
            h:'RoHS标准',
        },
        development:{
            a:'公司成立，踏入车联网领域车联网元年',
            b:'开发支持苹果MFI的iOBD2系列产品，为苹果MFI授权开发商，成为业界标杆',
            c:'腾讯路宝一代和二代',
            d:'摩拜共享单车锁',
            e:'与中兴物联合作开发4G OBD VM6200S',
            f:'无人健身仓解决方案,戴姆勒Car2Go智能车载终端供应商',
            g:'MB共享电单车锁',
            h:'摩拜共享汽车T-Box',
            i:'智能物流箱',
            j:'滴滴B1共享单车锁',
            k:'滴滴B2共享单车锁,in+智能门锁',
            l:'戴姆勒区块链T-Box,无人驾驶T-Box',
            m:'ECU远程标定T-Box,职业教育云平台'
        }
    },
    //footer底部
    footer:{
        a:'赋能物世界 ，创造慧生活',
        b:'媒体合作',
        c:'商务合作',
        d:'联系电话',
        e:'中国深圳',
        g:'北美研发中心',
        h:'工厂地址',
        i:'深圳市云伽未来技术有限公司',
        j:'深圳市福田区上梅林卓越城1期2栋2楼',
        l:'深圳市宝安区石岩街道塘头第三工业区12栋2楼',
        m:'版权所有 ',
        n:'©粤ICP备15075955号'
    },
    //新闻动态
    news:{
        top:"新闻动态",
        tab:{
            mediaReports:'媒体报道',
            information:"行业资讯",
            Company:"公司动态",
        },
        //媒体查询
        media:{
            message:'相约山东济南,朗仁科技在第86届全国汽配会等你！',
            message1:'10月11日-13日，第86届全国汽配会将在山东济南西部会展中心举办，朗仁科技携H6系列汽车、柴油车智能诊断平台参展。',
            message2:'深耕·超越·共赢，朗仁科技第六届经销商年会圆满落幕！',
            intelligent:'首款针对办公场景出入管理的智慧门锁面市，in+抢滩“线下流量入口',
            Source:"来源：新浪网",
            content:'2019年11月XX日深圳云伽未来科技有限公司（以下简称“云伽未来”）生产的in+玻璃门智慧锁正式面市，',
            text:'作为一款通过物联网技术赋能商业用户经营管理的智慧锁,产品在生产测试阶段就受到了来自物联网、智能门锁等行业的高度关注。',
            time:'巨头千万级单车锁核心供应商',
            core:'提起云伽未来科技很多人都很陌生，但细看其历年来的合作名单，却能看到“腾讯、阿里、滴滴、摩拜、瑞星、优信二手车、戴姆勒等行业巨头和头部的企业的身影，覆盖领域涵盖汽车领域、智能单车锁、智能硬件等，其中最耀眼的成绩是在共享单车鏖战最激烈的时刻，云伽未来每天的出货量能达到几百万台，截止目前市场供货总量早已是千万级别。前方市场激烈竞争，后方需要弹药充足供给，云伽未来在供给端的资源利用和配置能力无疑是极其突出的。通过软件设计、架构设计、制造生产、维修服务的打造，企业建立了自有的完备的供应链体系，而研发投入、产品迭代、反应速度、团队配置、服务支撑，尤其是对于高频、大体量客户的服务支撑，也保证了云伽未来一站式服务的输出。',
            core1:'“我们对于新领域、新行业、新业态的把握，对于产品方向的理解远远超过同行太多水平，这是很多头部企业愿意与我们合作，邀请我们参与产品顶层设计， 甚至意图把我们纳入其生态圈竞争壁垒的核心原因”云伽未来总经理孙继国表示。',
            core2:'在共享单车刚兴起的时候，行业里面没有供应商愿意或者敢于去设计和生产这种具有特殊功能的单车锁，云伽未来把握了市场机遇成为第一个吃螃蟹的人，不仅陪着合作伙伴一起成长为行业巨头，也累积了丰富的市场经验。虽然后期市场有很多效仿者，',
            core3:'但云伽未来已然是共享单车领域最大、行业经验最多的单车锁核心供应商。',
            market:'市场发力商用in+玻璃门智慧锁',
            market1:'有了滴滴、摩拜等核心客户的经验，有了千万级单车锁的设计、研发、生产、服务全链条服务，云伽未来考虑是否能为商业用户赋能，也推出一款具有聚焦性的智慧锁，这是初期市场考虑的雏形。但现实却是智能门锁市场鱼龙混杂，大部分以针对家用市场为主，而服务于商业端的产品不仅非常少，而且部分为了概念而概念，为了智能而智能，完全忽视用户体验的产品比比皆是。',
            market2:'针对这种情况，In+玻璃门智慧锁选择从细分市场入手，针对商用用户，包括企业办公、连锁门店玻璃门等场景。',
            market3:'目前市场面虽然很多企业都打“入户级”的概念，但企业员工的上下班痛点并未被真正解决，很多企业行政、人事购买的都是考勤系统，比如人脸识别打卡， 但真正的“入户级”应该是开关门场景，这是云伽市场部同事观察上班族上下班真实情境得出的结论。',
            market4:'早早到办公室，同事发现管理钥匙的行政没来苦苦等待；开门的同事因为各种原因（睡过头了，忘带钥匙，带错钥匙，交通情况等）没有到； ',
            market5:'人事、财务部的合同属于机密文件，安排同事去取文件发现没有钥匙；公司同事多，想要加班或者被指派加班发现不知道钥匙在谁那里；',
            market6:'同事出差异地带走钥匙，老板临时让取文件等等，这些情况每天实时发生在所有写字楼、商住楼、连锁门店，但却被众多商家忽略。',
            market7:'云伽未来考虑到这些场景的不便，以办公人性化角度切入，综合公司的运营管理成效，打造了in+玻璃门智慧锁。这款智慧锁采用物联网技术支撑，通过客户管理后台、APP、智慧锁三者进行门锁数据的授权、采集、管理，靠一靠就能开锁，真正实现“去钥匙化”操作，审批开锁流程操作简单，让办公场所的管理更透明化，大大提高进出办公场所的舒适度，把办公/门店管理放在口袋里。',
        },
        //行业资讯
        information:{
            header:'从长虹“物联网护照”说起：研读区块链与物联网的“链接网”',
            content:'10月24日，中央政治局就区块链技术发展现状和趋势进行了第十八次集体学习，提出加大该项领域的积极投入，着力攻克一批关键核心技术，加快推动区块链技术和产业创新发展后，由此，区块链再次成为坊间关注的焦点，引发多方热议。那么，区块链到底是什么？这一技术在我们的生活中有哪些应用？现阶段，我国相关产业的区块链技术衍进之路又发展到了那个阶段？',
            content1:'何谓区块链？区块链是分布式数据存储、点对点传输、共识机制、加密算法等计算机技术的新型应用模式，具有去中心化、不可篡改等特点，能有效降低个体间信任成本，从而提高生产效率，加快各个产业的转型升级。尤其对于以智能家居、智慧城市、车联网等应用场景为代表的物联网技术而言，产业化的日益加速与技术的安全可信之间的矛盾成为该领域急需解决的重要问题，而区块链技术的以上特性可以很好弥补当前物联网技术在安全领域上的缺陷，推动物联网设备及生态往更加安全的方向发展。',
            content2:'例如，在10月13日成都举办的2019CCF区块链大会——区块链与云大物智融合分论坛中，来自长虹信息安全灯塔实验室的首席科学家唐博所发表的有关《物联网分布式信任协同解决方案》主题演讲，其中正式提出的“物联网护照”机制，就是区块链技术在物联网安全领域应用取得突破性进展的一次典型性思路与成果展示。',
            content3:'据了解，物联网护照机制类似于现实护照机制，每个设备都可以申请获得全球唯一ID。在流程上类似我们现实中的签证，经过其他国家大使馆颁发签证，看出发国和目标国之间的协议，确定可开放何种类型的签证。对于家庭中的智能硬件商来说，这一在产品间都可通行的标准更将诞生诸多益处。比如，为电视的信任规则做授权，需要先为各设备发行物联网护照，促使设备与电视联动。原行为从电视发出后，经信任规则授权，确认电视行为没有问题，经由原平台（电视）上链，经过链上智能合约组成规则，传递到电灯、窗帘、电话、安防等其他设备上。这样的好处在于，信任可累积，每台设备的访问联动可做为激励的基础。',
            content4:'这样一来，长期困扰物联网以及智能家居产业的安全与连接问题将彻底成为过去，而你的生活中将有可能出现以下令人倍感舒适的场景：下班回家后，你呼唤家里的长虹电视开启，这时电视从你的语气中判断出你的心情并不是很好，因此向照明系统、空调发出感知指令——灯光柔和，空调将室温调节至舒适状态，电视自动播放轻柔的音乐，让你紧绷的情绪得以舒缓。也就是说用户在网络当中的任何位置都可以与智能家居以及互联网进行交互，最重要的是，你的这些智能家居设备可以不是同一品牌，通过长虹“物联网护照”机制构建的、符合X.1365标准的物联网设备唯一身份标识，基于区块链实现分布式身份认证与授权管理，未来的物联网智能家居体系将实现人与物、物与物、人与人互联关系、操作记录、联动记录等关键数据的摘要上链，实现数据确权、数据共享与隐私保护之间的友好共存，打破行业数据孤岛现象，实现真正跨平台互联互通。',
            content5:'当然，想要达成上述目标，仅仅凭借区块链技术也是不够的，先进而成熟的无线局域网模组、无线广域网模组、物联网感知应用等产品与解决方案也是非常关键的。多年来，长虹一直致力于国内家电行业深耕发展，目前已在行业内拥有了强有力的技术研发团队及领先的综合实力，其中，旗下子公司爱联科技自2016年12月成立至今，不仅满足了长虹自身的企业发展于产品相关的技术支持，还向国内众多相关产业领域提供必要的技术、产品、解决方案支持。截至目前，爱联科技已累计为超过2.6亿件产品提供了安全可靠的联接服务，现已成为中国大陆最大的物联网无线联接模组与感知应用产品及服务的研发与智能制造基地，是中国物联网无线联接行业的中坚力量。',
            content6:'在今年拉斯维加斯开幕的国际消费电子展中，长虹的全屋家电智能化方案更是得到了媒体及参观者的广泛关注与聚焦，方案中不仅有长虹自身在家电领域深厚的技术功底，更有现如今长虹在物联网、区块链、AI智能等新兴信息技术领域应用方面先导性的战略布局与引领行业的发展姿态。',
            content7:'总之，通过解读长虹“物联网护照”机制的技术特征与应用场景，我们不难从中读出区块链技术在物联网时代能够发挥的巨大作用，即区块链通过构建去中心化系统，可以为物联网提供基础设施架构支撑，并帮助解决物联网中无处不在的安全问题；而物联网则给区块链提供了大量的落地场景。',
            content8:'未来，区块链和物联网技术将进一步融合，发挥更大的经济效益。在国家政策和导向的支持下，未来物联网的发展一片大好，据预测，在2025年全球将有754.4亿台设备接入物联网，万物生长的发展态势将升级到全新的万物互联。我们有理由相信，未来，将有越来越多像长虹一样的企业紧跟国家步伐投身区块链、物联网技术的研发与普及，跻身全球领先的人工智能物联网企业行列，继续在两者深度融合的应用方向上积极探索，借助我国5G网络的铺设与相关技术迭代更新的全新风口，助力区块链和物联网实现价值传递，为推动我国产业转型升级贡献力量。',

        },
        //公司动态
        Company:{
            a:'云伽参展2019年英国伯明翰国际汽配展',
            b:'6月4-6日，朗仁科技参加了2019年英国伯明翰国际汽配展，展会在伯明翰国家展览中心举行。 在展会上，朗仁展出了最新产品——H6E，H6D Pro（柴油诊断设备），H6 Pro，诊简单，XVCI MAX。现场还展示有其他人气产品PS80、PS90、PS90HD柴油王、X100pad、X100C、X100 PRO、X100 pad2等。其中X100pad、X100C、X100 PRO、X100 pad2搭配KC100可以做大众四代五代于宝马CAS1-3++防盗匹配。诊简单——技术口袋的智能诊断仪，可以与手机和平板交互工作。XVCI MAX,支持原厂J2534诊断软件。 在展会期间，朗仁的展位吸引了参展朋友的目光，现场工作人员为他们讲解了新产品，同时参展人还现场体验操作了朗仁新产品。朗仁新品惊艳了参会人员。',
            f:'客户正在与我们的海外销售总监讨论该行业的良好前景和发达的技术'
        }
    },
    //联系我们
    contactUs: {
        tap: {
            a: "联系我们",
            b: "我们致力于为您提供丰富的服务咨询, 及全面的技术售后服务",
            c: "关注云伽未来",
            d: "官方微信",
            o:'官方微博',
            f: "公司地址",
            g: "深圳市南山区留仙大道创智云城A2栋17至18层",
            h: "客服电话",
            i: "400-668-3996 (周一至周日08:30-19:00)",
            j: "联系电话",
            k: "0755-83663102 / 0755-83461647",
            m: "工厂地址",
            n: "深圳市宝安区石岩街道塘头第三工业区12栋2楼"
        }
    },
    //element 组件
    element: {
        loadingText: "拼命加载中..."
    },

    //时间单位（备用）
    dateLabel: {
        years: "年",
        month: "月",
        week: "周",
        day: "日"
    }
}

export default zh;



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js